module.exports = __webpack_public_path__ + "img/partner1.d5796fa0.png";